/*
 * @Description: axios的封装
 * @Author: gao shuai
 * @Date: 2020-02-25 15:24:12
 * @LastEditTime: 2020-07-10 09:29:08
 * @LastEditors: gao shuai
 */
import axios from 'axios';
import { Message } from 'element-ui';
import { clearAuth, getToken } from './tokenService';
import SecurityService from './SecurityService';
import {
  url
} from './version';
/* 实例化axios */
const AxiosInstance = axios.create();
const IS_DEV = process.env.NODE_ENV !== 'production';

let redirecting401 = false;

function clearAllManagewebAuth() {
  clearAuth();
  try {
    new SecurityService().signOut();
  } catch (e) {
    /* ignore */
  }
  try {
    window.localStorage.removeItem('adminMenuRoles');
  } catch (e) {
    /* ignore */
  }
}

/** 登录页发起的鉴权失败不应整页重定向（避免误跳、重复提示） */
function isLoginFlowRequest(config) {
  if (!config || !config.url) return false;
  const u = String(config.url);
  return (
    u.indexOf('/Account/Login') >= 0 ||
    u.indexOf('LoginBySmsCode') >= 0 ||
    u.indexOf('/Account/LoginApi') >= 0
  );
}
// const DEV_BASEURL = 'http://192.168.32.113:8111'; // 开发模式的url
const DEV_BASEURL = url; // 开发模式的url
// const PRO_BASEURL = 'http://192.168.32.113:8111'; // 生产模式的url
const PRO_BASEURL = url; // 生产模式的url

/* 实例对象默认配置 */
AxiosInstance.defaults.baseURL = IS_DEV ? DEV_BASEURL : PRO_BASEURL; // 区分开发和正式基础路径
// AxiosInstance.defaults.responseType = 'json'; // 返回数据类型json
AxiosInstance.defaults.timeout = 100000; // 超时时间
AxiosInstance.defaults.headers = {
  // 'Content-Type': 'application/x-www-form-urlencoded',
  'Content-Type': 'application/json'
};
// let mgr = new Mgr();
/**
 * 请求拦截器
 */
AxiosInstance.interceptors.request.use(
  config => {
    let url = config.url;
    config.url = url + '?r=' + (Math.random() * 100000 + 1);
    // 附带登录后获得的访问令牌（ManageServer/AuthServer 走 Bearer + 自定义 v1. HMAC token 校验）
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截器：401 关闭已有 Message、清登录态并回登录页（登录接口本身的 401 除外）
 */
AxiosInstance.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status;
    if (status === 401 && !isLoginFlowRequest(error.config)) {
      if (!redirecting401) {
        redirecting401 = true;
        try {
          Message.closeAll();
        } catch (e) {
          /* ignore */
        }
        clearAllManagewebAuth();
        try {
          const base = window.location.href.split('#')[0];
          window.location.replace(`${base}#/login`);
        } catch (e) {
          window.location.hash = '#/login';
        }
      }
      error.message = '';
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default AxiosInstance;
